module.exports = __webpack_public_path__ + "img/joanna_erbel_11.b21bf0ca.png";